// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip__container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 12px;
    column-gap: 8px;
    font-size: 11px;
    background-color: #e1e1e1;
    border-radius: 100px;
    cursor: pointer;
}

.chip__text {
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./client/components/chip/chip.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".chip__container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 12px;\n    column-gap: 8px;\n    font-size: 11px;\n    background-color: #e1e1e1;\n    border-radius: 100px;\n    cursor: pointer;\n}\n\n.chip__text {\n    max-width: 80px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
